import EsusView from 'components/esus/EsusView'
import React from 'react'

export default props => {
  return <EsusView url='/pec/user/cds/atividadeColetiva' />
}
